import { ListResult } from '@lemoncloud/codes-backend-api/dist/cores/types';
import { SaveSecretBody, WorkspaceBody, WorkspaceView } from '@lemoncloud/codes-goods-api';
import { Params } from '@lemoncloud/lemon-web-core';

import { webCore } from '@codes/web-core';

import { UpdateWorkspaceDTO } from '../types';

const BACKEND_ENDPOINT = import.meta.env.VITE_BACKEND_ENDPOINT.toLowerCase();

export const fetchMyWorkspaces = async (params: Params): Promise<ListResult<WorkspaceView>> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BACKEND_ENDPOINT}/workspaces/0/list`,
        })
        .setParams({ ...params })
        .execute<ListResult<WorkspaceView>>();

    return { ...data };
};

export const fetchWorkspaces = async (params: Params): Promise<ListResult<WorkspaceView>> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BACKEND_ENDPOINT}/workspaces/0/list`,
        })
        .setParams({ ...params })
        .execute<ListResult<WorkspaceView>>();

    return { ...data };
};

export const fetchWorkspaceById = async (workspaceId?: string): Promise<WorkspaceView> => {
    if (!workspaceId) {
        throw new Error('fetchWorkspaceById: @workspaceId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BACKEND_ENDPOINT}/workspaces/${workspaceId}/detail`,
        })
        .execute<WorkspaceView>();

    return { ...data };
};

export const createWorkspace = async (workSpaceBody: WorkspaceBody): Promise<WorkspaceView> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BACKEND_ENDPOINT}/workspaces/0`,
        })
        .setBody({ ...workSpaceBody })
        .setParams({
            auto: 1,
            // NOTE: V2부터 필요없음
            // ...(workSpaceBody.request$?.email && workSpaceBody.request$?.phone && { auto: 1 }),
        })
        .execute<WorkspaceView>();

    return data;
};

export const updateWorkspace = async (updateWorkspaceBody: UpdateWorkspaceDTO): Promise<WorkspaceView> => {
    const { workspaceId, ...data } = updateWorkspaceBody;
    if (!workspaceId) {
        throw new Error('updateWorkspace: @workspaceId is required');
    }

    const response = await webCore
        .buildSignedRequest({
            method: 'PUT',
            baseURL: `${BACKEND_ENDPOINT}/workspaces/${workspaceId}`,
        })
        .setBody({ ...data })
        .execute<WorkspaceView>();

    return response.data;
};

export const deleteWorkspace = async (workspaceId: string): Promise<WorkspaceView> => {
    if (!workspaceId) {
        throw new Error('deleteWorkspace: @workspaceId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'DELETE',
            baseURL: `${BACKEND_ENDPOINT}/workspaces/${workspaceId}`,
        })
        .setBody({})
        .execute<WorkspaceView>();

    return data;
};

export const enrollAccessKey = async (body: SaveSecretBody): Promise<WorkspaceView> => {
    const { data } = await webCore
        .buildSignedRequest({ method: 'POST', baseURL: `${BACKEND_ENDPOINT}/workspaces/0/secret` })
        .setBody(body)
        .execute<WorkspaceView>();

    return data;
};

export const enrollAccessKeyWithWorkspaceId = async (
    workspaceId: string,
    body: SaveSecretBody
): Promise<WorkspaceView> => {
    const { data } = await webCore
        .buildSignedRequest({ method: 'POST', baseURL: `${BACKEND_ENDPOINT}/workspaces/${workspaceId}/secret` })
        .setBody(body)
        .execute<WorkspaceView>();

    return data;
};

/**
 * Update workspace Gemini API Key
 */
export const updateWorkspaceGeminiKey = async (workspaceId: string, geminiApiKey: string): Promise<WorkspaceView> => {
    if (!workspaceId) {
        throw new Error('updateWorkspaceGeminiKey: @workspaceId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${BACKEND_ENDPOINT}/workspaces/${workspaceId}/api-key`,
        })
        .setBody({ geminiApiKey })
        .execute<WorkspaceView>();

    return data;
};
